import React, {Component} from 'react'

import Screen from '../ui/Screen'

import ControlPanel from './BalanceScreen/ControlPanel'
import SearchPanel from './BalanceScreen/SearchPanel'
import CreateFolderDialog from './BalanceScreen/CreateFolderDialog'
import SelectItemDialog from '../inventory/SelectItemDialog'
import ErrorMessageDialog from "./../ui/ErrorMessageDialog"
import DeleteFolderDialog from "./BalanceScreen/DeleteFolderDialog"
import DeleteItemDialog from "./BalanceScreen/DeleteItemDialog"
import IncomeDialog from "./BalanceScreen/IncomeDialog"
import OutcomeDialog from "./BalanceScreen/OutcomeDialog"

import SelectFolderDialog from "./../ui/SelectFolderDialog"
import ExpandState from "./../ui/ExpandState"
import TreeList from "./BalanceScreen/TreeList"
import ItemIcon from '@material-ui/icons/BeachAccess'

import Cookie from "../Cookie"
import {config} from "../config"

/**
 * <BalanceScreen />
 */

class BalanceScreen extends Component {

  state = {
    items: [],
    selected: undefined,
    dialog: undefined,
    search: "",
  }

  expandState = new ExpandState()

  /**
   * Конструктор.
   */

  constructor(props) {
    super(props)
    this.handle_createFolderClick = this.handle_createFolderClick.bind(this)
    this.handle_createItemClick = this.handle_createItemClick.bind(this)
    this.handle_moveToFolderClick = this.handle_moveToFolderClick.bind(this)
    this.handle_deleteItemClick = this.handle_deleteItemClick.bind(this)
    this.handle_searchChange = this.handle_searchChange.bind(this)
    this.handle_clickItem = this.handle_clickItem.bind(this)
    this.handle_incomeClick = this.handle_incomeClick.bind(this)
    this.handle_outcomeClick = this.handle_outcomeClick.bind(this)
    this.handle_error = this.handle_error.bind(this)
  }

  /**
   * Находит выбранные элемент в обновленном списке.
   * Нужно, так как выбранное в обновленном списке и выбранное ранее не одно и тоже.
   * @param selected - выбранный элемент.
   * @param items - обновленный список.
   * @return найденный элемент.
   */

  findNewSelected(selected, items) {
		if (selected) {
			for(let item of items) {
				if (item.id === selected.id) {
					return item
				}
				if (item.type.toString() === "0") {
					let itm = this.findNewSelected(selected, item.items)
					if (itm) {
						return itm
					}
				}
			}
		}
	}

  /**
   * Открывает родительский папки для выбранного элемента.
   * @param item - предмет (обычно state.selected)
   */

  expandSelectedParents(item) {
		let itm = item
		while(itm) {
      if (itm.type === '0') {
        itm.expand = true
				this.expandState.set(itm.id, itm.expand)
      }
      itm = itm.parent
		}
		return item
	}

  /**
   * Получает список предметов баланса.
   * @return Promise.resolve(balance)
   */

  getBalance() {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("GET", config.restApiHost + `/acc/balance?sid=${Cookie.get("sid")}&search=${encodeURIComponent(this.state.search)}`, true)
      xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
            if (this.state.search && this.state.search.length) {
              resolve(json)
            } else {
              // получаем указатель на папку владельца
  						let normalize = (items, parent) => {
  							if (items) {
  								for(let item of items) {
  									item.parent = parent
  									if (item.type === "0") {
  										item.items = normalize(item.items, item)
  									}
  								}
  							}
  							return items
              }
              resolve(normalize(json, undefined))
            }
					} else {
						reject("Не удалось получить список предметов баланса")
					}
				}
      }
      xhr.send()
    })
  }

  /**
   * Создать папку.
   * @param parentObject - объект предок (обычно this.state.selected).
   * @param folderName - имя папки.
   * @return Promise.resolve()
   */

  createFolder(parentFolderId, folderName) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("POST", config.restApiHost + `/acc/balance/folder?sid=${Cookie.get("sid")}&parentFolderId=${parentFolderId}&folderName=${encodeURIComponent(folderName)}`, true)
      xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось создать папку")
					}
				}
      }
      xhr.send()
    })
  }

  /**
   * Добавляет предмет.
   * @param parentFolderId - родительская папка.
   * @param itemId - `id` предсета.
   * @return Promise.
   */

  createItem(parentFolderId, itemId) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("POST", config.restApiHost + `/acc/balance/item?sid=${Cookie.get("sid")}&itemId=${itemId}&parentFolderId=${parentFolderId}`, true)
      xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось добавить предмет")
					}
				}
      }
      xhr.send()
    })
  }

  /**
   * Удалить предмет или папку.
   * @param itemId - `id` удаляемого объекта.
   * @return Promise
   */

  deleteItem(itemId) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("DELETE", config.restApiHost + `/acc/balance?sid=${Cookie.get("sid")}&itemId=${itemId}`, true)
      xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось удалить позицию.")
					}
				}
      }
      xhr.send()
    })
  }

  /**
   * Обновление состояния.
   * @return Promise.resolve()
   */

  update() {
    return new Promise((resolve, reject) => {
      this.getBalance().then(
        balance => {
          this.expandState.updateTree(balance)
          let selected = this.findNewSelected(this.state.selected, balance)
          this.expandSelectedParents(selected)
          this.setState({
            items: balance,
            selected: selected,
          }, resolve)
        },
        reject
      )
    })
  }

  /**
   * Событие монтирования компонента.
   */

  componentDidMount() {
    this.update()
  }

  /**
   * Обработчик нажатия кнопки "Создать папку" на контрольной панели.
   * @param selected - текущий выбранный элемент. Если это папка, то добавить в эту папку.
   */

  handle_createFolderClick(selected) {
    this.setState({
			dialog: <CreateFolderDialog
				selected = {this.state.selected}
				onCreateFolder = {folder => {

          let parentFolderId = (selected => {
            if (selected) {
              if (selected.type === '0') {
                return selected.id
              } else {
                return selected.folder_id
              }
            }
            return `0`
          })(selected)


					this.createFolder(parentFolderId, folder.name).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
  }

  /**
   * Обработка ошибки.
   * @param errorMessage - сообщение об ошибке.
   */

  handle_error(errorMessage) {
    this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
					}, this.handleError)
				}}
			/>
		})
  }

  /**
   * Обработчик нажатия кнопки "Создать предмет" на контрольной панели.
   * @param selected - текущий выбранный элемент. Если это папка, то добавить в эту папку.
   */

  handle_createItemClick(selected) {
    this.setState({
      dialog: <SelectItemDialog
        onSelectItem = {item => {
          let parentFolderId = (selected => {
            if (selected) {
              if (selected.type === '0') {
                return selected.id
              } else {
                return selected.folder_id
              }
            }
            return `0`
          })(selected)
          this.createItem(parentFolderId, item.id).then(
            () => {
              this.update().then(() => {
  							this.setState({
  								dialog: undefined
  							})
  						}, this.handleError)
            },
            this.handle_error
          )
        }}
        onCancel = {() => {
          this.setState({
            dialog: undefined,
          })
        }}
      />
    })
  }

  /**
	 * Проверяет, можно ли скопировать итем или папку в заданную папку
	 * Нельзя, если item = папка и заданная папака находится
	 * внутри копируемой папки или является собой (нельзя копировать в себя)
	 *
	 * @param item - объкт копируемый предмета.
	 * @param folder - папка в которую копируют.
	 */

	itemReadyToMove(item, folder) {
		return new Promise((resolve, reject) => {

			let scan = f => {
				if (!folder) { // любую папку можно коипировать в корень
					return true
				}
				if (f.id === folder.id) {
					return false
				}
				for (let itm of f.items) {
					if (itm.type === "0") {
						if (!scan(itm)) {
							return false
						}
					}
				}
				return true
			}

			if (item.type === "0") { // move folder
				if (scan(item)) {
					resolve(item, folder)
				} else {
					reject("Нельзя копировать папку в себя, или во вложенные папки")
				}
			} else { // move item
				resolve(item, folder)
			}

		})
	}

  /**
   * Переносит предмет или папку в другую папку.
   * @param itemId - `id` предмета.
   * @param folder - `id` папки.
   * @return Promise
   */

  moveToFolder(itemId, folderId) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
      xhr.open("PUT", config.restApiHost + `/acc/balance/move?sid=${Cookie.get("sid")}&itemId=${itemId}&folderId=${folderId}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Ну удалось переместить предмет")
					}
				}
			}
			xhr.send()
		})
	}

  /**
   * Обработчик нажатия кнопки "Удалить" на контрольной панели.
   * @param selected - текущий выбранный элемент который нужно удалить.
   */

  handle_moveToFolderClick(selected) {
    this.setState({
      dialog: <SelectFolderDialog
        items = {this.state.items}
        disableFolder = {selected}
        onSelectFolder = {folder => {
          this.itemReadyToMove(selected, folder).then(result => {
            this.moveToFolder(selected.id, folder.id).then(() => {
              this.update().then(() => {
                this.setState({
                  selected: this.expandSelectedParents(selected),
                  dialog: undefined,
                })
              }, this.handleError)
            }, this.handleError)
          }, this.handleError)
        }}
        onCancel = {() => {
          this.setState({
            dialog: undefined
          })
        }}
      />
    })
  }

  /**
   * Удалить элемент списка.
   * @param selected - выбранный элемент, который нужно удалить.
   */

  handle_deleteItemClick(item) {
    if (item.type === "1") {
			this.setState({
				dialog: <DeleteItemDialog
					item = {item}
					onDeleteItem = {item => {
						this.deleteItem(item.id).then(() => {
							this.update().then(() => {
								this.setState({
									selected: undefined,
									dialog: undefined,
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		} else {
			this.setState({
				dialog: <DeleteFolderDialog
					folder = {item}
					onDeleteFolder = {folder => {
						this.deleteItem(folder.id).then(() => {
							this.update().then(() => {
								this.setState({
									selected: undefined,
									dialog: undefined,
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		}
  }

  /**
   * Обработка изменения строки поиска.
   * @param search - новая строка поиска.
   */

  handle_searchChange(search) {
    this.setState({
      search: search,
    }, this.update)
  }

  /**
   * Обработка нажатия на элемент дерева предметов.
   * @param item - предмет на который кликнули.
   */

  handle_clickItem(item) {
    if (this.state.selected ? this.state.selected.id === item.id : false) {
      if (this.state.search && this.state.search.length) {
        this.setState({
          search: ""
        }, () => {
          this.update().then(() => {
            let selected = this.findNewSelected(item, this.state.items)
            this.expandSelectedParents(selected)
            this.setState({
              selected: selected
            })
          })
        })
      } else {
        if (this.state.selected.type === "0") {
  				item.expand = !item.expand
  				this.expandState.set(item.id, item.expand)
  				this.forceUpdate()
  			} else {
  				//this.handleEditItem(item)
  			}
      }
		} else {
			this.setState({
				selected: this.expandSelectedParents(item),
			})
		}
  }

  /**
   * Прием предмета.
   *
   * @param balanceItemId - `id` предмета в таблице `balance`.
   * @param amount - количество предметов.
   * @param comment - комментарий.
   */

  income(balanceItemId, amount, comment) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("POST", config.restApiHost + `/acc/balance/income?sid=${Cookie.get("sid")}&balanceItemId=${balanceItemId}&amount=${amount}&comment=${encodeURIComponent(comment)}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Ну удалось принять предмет")
					}
				}
			}
			xhr.send()
    })
  }

  /**
   * Прием.
   */

  handle_incomeClick(item) {
    this.setState({
      dialog: <IncomeDialog
        item = {item}
        amount = {0}
        onIncome = {(amount, comment) => {
          this.income(item.id, amount, comment).then(() => {
            this.update().then(() => {
              this.setState({
                dialog: undefined,
              })
            }, this.handle_error)
          }, this.handle_error)
        }}
        onCancel = {() => {
          this.setState({
            dialog: undefined,
          })
        }}
      />
    })
  }

  /**
   * Выдача предмета.
   *
   * @param balanceItemId - `id` предмета в таблице `balance`.
   * @param amount - количество предметов.
   * @param comment - комментарий.
   */

  outcome(balanceItemId, amount, comment) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open("POST", config.restApiHost + `/acc/balance/outcome?sid=${Cookie.get("sid")}&balanceItemId=${balanceItemId}&amount=${amount}&comment=${encodeURIComponent(comment)}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Ну удалось списать предмет")
					}
				}
			}
			xhr.send()
    })
  }

  /**
   * Выдача.
   */

  handle_outcomeClick(item) {
    this.setState({
      dialog: <OutcomeDialog
        item = {item}
        amount = {0}
        onOutcome = {(amount, comment) => {
          this.outcome(item.id, amount, comment).then(() => {
            this.update().then(() => {
              this.setState({
                dialog: undefined,
              })
            }, this.handle_error)
          }, this.handle_error)
        }}
        onCancel = {() => {
          this.setState({
            dialog: undefined,
          })
        }}
      />
    })
  }

  /**
   * Построение компонента.
   */

  render() {

    return <Screen
      onClick = {e => {
        e.stopPropagation()
        this.setState({
          selected: undefined
        })
      }}
    >

      {this.state.dialog}

      <ControlPanel
        selected = {this.state.selected}
        onCreateFolderClick = {this.handle_createFolderClick}
        onCreateItemClick = {this.handle_createItemClick}
        onMoveToFolderClick = {this.handle_moveToFolderClick}
        onDeleteItemClick = {this.handle_deleteItemClick}
        onIncomeClick = {this.handle_incomeClick}
        onOutcomeClick = {this.handle_outcomeClick}
      />

      <SearchPanel
        onChange = {this.handle_searchChange}
      />

      <TreeList
				items = {this.state.items}
				selected = {this.state.selected}
				itemIcon = {<ItemIcon/>}
				onClickItem = {this.handle_clickItem}
			/>

    </Screen>

  }

}

export default BalanceScreen
